/// <amd-module name="SuiteCommerce.Blog.ExtCarousel.Indicator.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.ExtCarousel.Indicator.Collection", ["require", "exports", "Backbone", "SuiteCommerce.Blog.ExtCarousel.Indicator.Model"], function (require, exports, Backbone_1, ExtCarousel_Indicator_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ExtCarouselIndicatorCollection = /** @class */ (function (_super) {
        __extends(ExtCarouselIndicatorCollection, _super);
        function ExtCarouselIndicatorCollection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.model = ExtCarousel_Indicator_Model_1.ExtCarouselIndicatorModel;
            return _this;
        }
        return ExtCarouselIndicatorCollection;
    }(Backbone_1.Collection));
    exports.ExtCarouselIndicatorCollection = ExtCarouselIndicatorCollection;
});
